import { zodLess, ZodLessInfer } from '@kaiizen/zod-less';

export const ApiReportTypeSchema = zodLess('fullScope|changeOrder|punchlist|closeout');
export type ApiReportType = ZodLessInfer<typeof ApiReportTypeSchema>;

export const ApiReportTypes = ApiReportTypeSchema.options;
